module.exports = __webpack_public_path__ + "static/media/kenn_btn_falsch.ad7b3c2c.jpg";